export default __webpack_public_path__ + "static/media/4.41f74238.jpg";